import { RootState } from '../store'

export const getSnackbarMessage = (state: RootState) => {
    return { message: state.snackbar.message, type: state.snackbar.type }
}
export const isSnackbarOpen = (state: RootState) => state.snackbar.open
